export default __webpack_public_path__ + "images/19ebf6251f1d041e489becb651a6b10a.png";